module.exports = __webpack_public_path__ + "static/media/arrow-downward.28818c19.svg";